import './pages-nav.component.scss'

import $ from 'jquery'

$(document).ready(function () {
  const nav = $('.pages-nav');
  const body = $('body');
  const intro = $('.intro');
  const offset = intro.length > 0 ? intro.height() + intro.offset().top : 768;
  if (nav.length > 0) {
    body.addClass('page-navigator-active');
    $(window).scroll(function () {
      if ($(window).scrollTop() > offset) {
        nav.addClass('pages-nav--active');

      } else {
        nav.removeClass('pages-nav--active');
      }
    }).trigger('scroll');
  }
});